import { render, staticRenderFns } from "./signPayReturn.vue?vue&type=template&id=6fdf53b4&scoped=true"
import script from "./signPayReturn.vue?vue&type=script&lang=js"
export * from "./signPayReturn.vue?vue&type=script&lang=js"
import style0 from "./signPayReturn.vue?vue&type=style&index=0&id=6fdf53b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdf53b4",
  null
  
)

export default component.exports